<template>
  <!-- 根因分析 (根据业绩、要事的差距描述逐一进行根因分析) -->
  <div class="table_container">
    <div class="table-btn" style="margin: 24px 0 12px 0">
      <el-button
        :disabled="tableData.length >= 10"
        type="primary"
        size="small"
        @click="handleAdd()"
        >添加</el-button
      >
    </div>
    <el-table
      ref="tableRef"
      highlight-current-row
      :border="true"
      :data="tableData"
      :header-cell-style="{
        background: '#EFEFEF',
        color: '#000',
        borderColor: '#dcdfe6'
      }"
      :cell-class-name="cellClassName"
      @cell-click="handleCellClick"
    >
      <!-- 序号 -->
      <el-table-column label="序号" width="50px" align="center">
        <template slot-scope="scope">
          {{ scope.$index + 1 }}
        </template>
      </el-table-column>
      <!-- 差距来源 -->
      <el-table-column
        prop="gapSource"
        label="差距来源"
        min-width="90px"
        align="center"
      >
        <template slot-scope="scope">
          <el-select
            v-if="editField === 'gapSource' && editIndex === scope.$index"
            id="focusRef"
            v-model="scope.row.gapSource"
            placeholder="请选择"
            filterable
            clearable
            size="mini"
            automatic-dropdown
            @visible-change="visibleChange"
            @change="confirmEdit"
          >
            <el-option label="业绩指标" value="业绩指标"></el-option>
            <el-option label="要事" value="要事"></el-option>
            <el-option label="其他机会差距" value="其他机会差距"></el-option>
          </el-select>
          <div v-else>
            {{ scope.row.gapSource }}
          </div>
        </template>
      </el-table-column>
      <!-- 差距描述 -->
      <el-table-column
        prop="gapDescription"
        label="差距描述"
        min-width="90px"
        align="center"
      >
        <template slot-scope="scope">
          <el-input
            v-if="editField === 'gapDescription' && editIndex === scope.$index"
            id="focusRef"
            v-model="scope.row.gapDescription"
            size="mini"
            style="width: 100%"
            @blur="confirmEdit"
            @keyup.enter.native="confirmEdit"
          ></el-input>
          <div v-else>
            {{ scope.row.gapDescription }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="根因(聚焦工作方法及计划)" align="center">
        <!-- 根因描述 -->
        <el-table-column
          prop="rootDescription"
          label="根因描述"
          min-width="90px"
          align="center"
        >
          <template slot-scope="scope">
            <el-input
              v-if="
                editField === 'rootDescription' && editIndex === scope.$index
              "
              id="focusRef"
              v-model="scope.row.rootDescription"
              size="mini"
              style="width: 100%"
              @blur="confirmEdit"
              @keyup.enter.native="confirmEdit"
            ></el-input>
            <div v-else>
              {{ scope.row.rootDescription }}
            </div>
          </template>
        </el-table-column>
        <!-- 改善策略 -->
        <el-table-column
          prop="improvementStrategy"
          label="改善策略"
          min-width="90px"
          align="center"
        >
          <template slot-scope="scope">
            <el-input
              v-if="
                editField === 'improvementStrategy' &&
                  editIndex === scope.$index
              "
              id="focusRef"
              v-model="scope.row.improvementStrategy"
              size="mini"
              style="width: 100%"
              @blur="confirmEdit"
              @keyup.enter.native="confirmEdit"
            ></el-input>
            <div v-else>
              {{ scope.row.improvementStrategy }}
            </div>
          </template>
        </el-table-column>
      </el-table-column>
      <!-- 深层次根因及感悟(聚焦组织能力和领导力)(如有) -->
      <el-table-column
        prop="importantPerception"
        label="深层次根因及感悟(聚焦组织能力和领导力)(如有)"
        min-width="90px"
        align="center"
      >
        <template slot-scope="scope">
          <el-input
            v-if="
              editField === 'importantPerception' && editIndex === scope.$index
            "
            id="focusRef"
            v-model="scope.row.importantPerception"
            size="mini"
            style="width: 100%"
            @blur="confirmEdit"
            @keyup.enter.native="confirmEdit"
          ></el-input>
          <div v-else>
            {{ scope.row.importantPerception }}
          </div>
        </template>
      </el-table-column>
      <!-- 备注 -->
      <el-table-column
        prop="remark"
        label="备注"
        min-width="90px"
        align="center"
      >
        <template slot-scope="scope">
          <el-input
            v-if="editField === 'remark' && editIndex === scope.$index"
            id="focusRef"
            v-model="scope.row.remark"
            size="mini"
            style="width: 100%"
            @blur="confirmEdit"
            @keyup.enter.native="confirmEdit"
          ></el-input>
          <div v-else>
            {{ scope.row.remark }}
          </div>
        </template>
      </el-table-column>
      <!-- 操作 -->
      <el-table-column label="操作" align="center" width="90px" fixed="right">
        <template slot-scope="scope">
          <!-- 删除 -->
          <el-button size="mini" type="text" @click="handleDelete(scope.$index)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { addOrUpdateRootCauseAnalysisApi } from "@/api/saleTaskCollection";

export default {
  data() {
    return {
      queryParams: {},
      tableData: [],
      editField: "", // 编辑单元格
      editIndex: -1 // 编辑行索引
    };
  },
  methods: {
    init(data, queryParams = {}) {
      this.tableData = data || [];
      this.queryParams = { ...queryParams };
    },
    // 添加
    handleAdd() {
      this.tableData.push({
        gapSource: "", // 差距来源
        gapDescription: "", // 差距描述
        rootDescription: "", // 根因描述
        improvementStrategy: "", // 改善策略
        importantPerception: "", // 深层次根因及感悟(聚焦组织能力和领导力)(如有)
        remark: "" // 备注
      });
    },
    // 删除
    handleDelete(index) {
      this.tableData.splice(index, 1);
    },
    // 获取单元格索引
    cellClassName({ row, column, rowIndex, columnIndex }) {
      row.index = rowIndex;
      column = { ...column, index: columnIndex };
    },
    // 点击单元格
    handleCellClick(row, column) {
      this.handleColumn(column.property, row.index ?? -1);
      this.tableData[row.index][column.property] =
        this.tableData[row.index][column.property] ?? undefined;
    },
    // 点击单元格编辑
    handleColumn(field, index) {
      this.editField = field;
      this.editIndex = index ?? -1;
      this.$nextTick(() => {
        document.querySelector("#focusRef")?.focus();
        document.querySelector("#focusRef .el-input__inner")?.focus();
      });
    },
    // 确认编辑
    confirmEdit() {
      this.editField = "";
      this.editIndex = -1;
    },
    // el-select 显示隐藏选项框时触发
    visibleChange(visible) {
      if (!visible) {
        this.confirmEdit();
      }
    },
    // 保存
    async handleSave(callBack) {
      try {
        const submitData = {
          ...this.queryParams,
          dataList: JSON.parse(JSON.stringify(this.tableData))
        };
        const res = await addOrUpdateRootCauseAnalysisApi(submitData);
        if (res.status == 0) {
          this.$DonMessage.success("操作成功！");
          this.tableData = res.data;
          callBack();
        } else {
          this.$DonMessage.error(res.message);
        }
      } catch (error) {
        console.error(error);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.table_container {
  padding: 15px 18px 0 50px;
  .number_input {
    width: 100%;
    padding: 0;
    ::v-deep .el-input__inner {
      padding: 0 8px;
    }
  }
}
</style>
